import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Bank } from 'src/app/assabil-kernel/models/entities/control-tables/bank';
import { BankRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/bank-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Component({
    selector: 'bank-list',
    templateUrl: './bank-list.component.html',
    styleUrls: ['./bank-list.component.scss']
})


export class BankListComponent extends BasePage2<Bank> {

    // Filter fields
    // ---------------------------------------------------
    code: string;
    name: string;
    // ---------------------------------------------------
        
    // ---------------------------------------------------
    banks: Bank[] = [];
    // ---------------------------------------------------
    

    constructor(
        protected toastr                : ToastrService,
        protected router                : Router,
        protected controlTablesService  : ControlTablesService,
        protected baseService           : BaseService,
        protected leanUtilsService      : LeanUtilsService,
        protected location              : Location) {
        super(toastr, router, baseService, leanUtilsService, location);

        this.entityName = 'bank';
    }

    // ---------------------------------------------------
 

    // ---------------------------------------------------
    getRows(): Bank[] {
        return this.banks;
    }
    // ---------------------------------------------------


    // ---------------------------------------------------
    saveRow(row: Bank): Promise<Bank> {
        let request: BankRequest = new BankRequest(this.controlTablesService.getUserInfo());
        request.bank = row;
        return this.controlTablesService.save(this.entityName, request);
    }
    // ---------------------------------------------------



    //----------------------------------------------------------------------
    new(){
        let bank : Bank = new Bank();
        bank.inserted = true;
        bank.edit = true;
        this.banks.push(bank);
        this.banks = [...this.banks];
        }  
   //----------------------------------------------------------------------
 

//----------------------------------------------------------------------
    loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
        request.strArg1 = this.code;
        request.strArg2 = this.name;

        this.controlTablesService.getList(this.entityName, request).then(result => {
            this.banks = result;
        })
    }
//----------------------------------------------------------------------

}
